export default __webpack_public_path__ + "static/media/floral.4952d602.jpg";